<template>
  <v-dialog v-model="showModal" persistent max-width="500px">
    <v-card class="mx-auto">
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
        <v-chip small="" color="blue" class="white--text"
          >{{ step }} / 2</v-chip
        >
      </v-card-title>
      <v-window v-model="step">
        <!-- Pick Course -->
        <!-- Course properties -->
        <v-window-item :value="1">
          <v-card flat>
            <!-- <v-select
                :items="prices"
                label="Price"
                :value="100"
                v-model="form.properties.priceObject"
                :item-text="showPrice"
                :item-value="obj => obj"
              >
              </v-select> -->
            <!-- <span class="subtitle-1">Price</span> -->
            <v-card-text
              ><span class="body-1">Price</span>
              <v-text-field
                class="mt-0 pt-0"
                min="0"
                prefix="$"
                max="120"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                type="number"
                step="1"
                :rules="pricerules"
                v-model="form.logistics.price"
              ></v-text-field
            ></v-card-text>
          </v-card>
          <v-card flat>
            <v-card-text class="body-1 mb-0 pb-0 pt-1">
              Allow users to enroll with just a phone number?
              <v-switch
                class="pa-0 ma-0 mt-2"
                :disabled="form.properties.price > 0"
                :label="form.properties.allowAnonymousUsers ? 'Yes' : 'No'"
                color="blue"
                v-model="form.properties.allowAnonymousUsers"
              ></v-switch>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-text class="body-1 mb-0 pb-0 pt-1">
              Make accessible through share link only?
              <v-switch
                class="pa-0 ma-0 mt-2"
                :label="form.properties.hidden ? 'Yes' : 'No'"
                color="blue"
                v-model="form.properties.hidden"
              ></v-switch>
            </v-card-text>
          </v-card>
          <v-card flat class="d-none d-md-flex">
            <v-card-text class="body-1 mb-0 pb-0 pt-1 pb-2">
              What days should Arist skip sending messages?
              <v-btn-toggle
                v-model="form.properties.skipDays"
                multiple
                color="red"
                style="width:100%"
                class="mt-2"
              >
                <v-btn
                  :disabled="
                    !form.properties.skipDays.includes(item) &&
                      form.properties.skipDays.length >= MAX_SKIP_DAYS
                  "
                  :width="`${100 / daySelections.length}%`"
                  v-for="item in daySelections"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </v-btn>
              </v-btn-toggle>
            </v-card-text>
          </v-card>
          <v-card flat class="mt-0 pt-0">
            <v-card-text class="body-1 mb-0 pb-0 pt-1">
              Require an access code to enroll?
              <v-switch
                class="pa-0 ma-0 mt-2"
                :label="form.properties.requireAccessCode ? 'Yes' : 'No'"
                color="blue"
                v-model="form.properties.requireAccessCode"
              ></v-switch>
              <v-slide-y-transition>
                <v-text-field
                  v-if="form.properties.requireAccessCode"
                  v-model="form.properties.accessCode"
                  label="Access Code"
                ></v-text-field>
              </v-slide-y-transition>
            </v-card-text>
          </v-card>
        </v-window-item>
        <!-- Review and create -->
        <v-window-item :value="2">
          <v-card flat="" class="pa-0 ma-0">
            <v-list-item three-line>
              <v-list-item-avatar tile size="110px">
                <v-img
                  :src="form.course.imglink"
                  max-height="110"
                  contain
                  position="left"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content class="pb-1">
                <v-list-item-title class="headline">{{
                  form.course.name || "No name"
                }}</v-list-item-title>
                <v-list-item-title class="subtitle-1 font-weight-regular">
                  <b>Price: </b
                  >{{
                    form.properties.price == 0
                      ? "Free"
                      : "$" + form.logistics.price
                  }}
                </v-list-item-title>
                <v-list-item-title class="subtitle-1 font-weight-regular">
                  <b>Phone Only Accounts: </b>
                  {{
                    form.properties.allowAnonymousUsers
                      ? "Allowed"
                      : "Not allowed"
                  }}
                </v-list-item-title>
                <v-list-item-title class="subtitle-1 font-weight-regular">
                  <b>Accessible: </b>
                  {{
                    form.properties.hidden
                      ? "Only with share URL"
                      : "By front page"
                  }}
                </v-list-item-title>
                <v-list-item-title class="subtitle-1 font-weight-regular">
                  <b>Access Code: </b>
                  {{
                    form.properties.requireAccessCode
                      ? `Required - ${form.properties.accessCode}`
                      : "Not needed"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn depressed color="grey white--text" @click="getBack()">
          {{ step > 1 ? "Back" : "Cancel" }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="isDisabled"
          color="primary"
          depressed
          @click="nextStep()"
        >
          {{ step >= 2 ? "Save and Close" : "Next" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import services from "@/services/index.js";
export default {
  props: ["dialog", "document"],
  data: () => ({
    MAX_SKIP_DAYS: 6,
    daySelections: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"],
    step: 1,
    form: {
      course: {
        name: ""
      },
      _id: "",
      logistics: {
        price: 0,
        copies: 0,
        limitCopies: false
      },
      properties: {
        allowAnonymousUsers: false,
        hidden: false,
        skipDays: [],
        requireAccessCode: false,
        accessCode: "",
        disabled: false
      }
    },
    pricerules: [
      value => value != undefined || "Required.",
      value => (value || 0) < 120 || "Max price 120 dollars.",
      value => value >= 0 || "Price must be postive."
    ],
    cleanForm: {
      course: {
        name: ""
      },
      _id: "",
      logistics: {
        price: 0,
        copies: 0,
        limitCopies: false
      },
      properties: {
        skipDays: [],
        allowAnonymousUsers: false,
        hidden: false,
        requireAccessCode: false,
        accessCode: "",
        disabled: false
      }
    }
  }),
  watch: {
    document() {
      if (this.document == null) {
        return;
      }
      console.log("Setting Document");
      this.form = JSON.parse(JSON.stringify(this.document));
    }
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Enrollment Options";
        case 2:
          return "Review and Save";
        default:
          return "Share Course";
      }
    },
    showModal() {
      return this.dialog && !this.isSaving;
    },
    isDisabled() {
      return false;
    }
  },
  methods: {
    getBack() {
      if (this.step > 1) {
        return this.step--;
      }
      this.cleanFields();
      this.$emit("cancel");
    },
    cleanFields() {
      this.form = JSON.parse(JSON.stringify(this.cleanForm));
      this.step = 1;
    },
    async nextStep() {
      if (this.step >= 2) {
        await this.onSave();
        this.$emit("finish");
        this.cleanFields();
        return;
      }
      this.step++;
    },
    async onSave() {
      try {
        window.analytics.track("Distribution Updated");
      } catch (err) {
        console.error(err);
      }
      await services.delivery.update({
        id: this.form._id,
        document: this.form,
        type: "public"
      });
    }
  }
};
</script>
